module.exports = __webpack_public_path__ + "media/images/vector-102@2x-e0ec4a3124f82b3afc03774d1c85134a.png";